module.exports = __webpack_public_path__ + "assets/img/audience1.be8ce44a.svg";